import type { ReactNode } from 'react'
import { SectionCard, EmptyState } from '@/components/ui'

/** Reusable empty-state tab body (Diligence, Files). */
export function GenericEmptyTab({ icon, title, hint }: { icon?: ReactNode; title: string; hint?: ReactNode }) {
  return (
    <SectionCard pad>
      <EmptyState icon={icon} title={title} hint={hint} />
    </SectionCard>
  )
}
